import React from 'react';
import { Select } from 'antd';
import {
  showNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';

class MultipleSelect extends React.Component {
  state = {
    value: this.props.defaultValue ? this.props.defaultValue.split(',') : [],
    searchValue: '',
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { defaultValue } = this.props;
    if (defaultValue !== prevProps.defaultValue) {
      this.setState({
        value: defaultValue ? defaultValue.split(',') : [],
      });
    }
  }

  handleSearch = (searchValue) => {
    this.setState({ searchValue });
  };

  handleChange = (value) => {
    const { domain_type } = this.props;
    const domain = value[value.length - 1];
    const deleteDomain = this.state.value.filter((e) => !value.includes(e))[0];
    const deleteDomainUuid = this.props.customDomainIndicators.filter(
      (e) => deleteDomain === e.domain,
    )[0]?.uuid;

    // const defaultDomains = this.props.defaultValue.split(',');

    if (
      domain &&
      !domain.includes(',') &&
      domain.includes('.') &&
      !(domain[0] === '.') &&
      !(domain[domain.length - 1] === '.') &&
      !this.state.value.includes(domain)
    ) {
      this.props.setCustomDomainIndicators({ domain, domain_type });
      // this.props.loadCustomDomainIndicators();
    } else if (deleteDomain && this.state.value.includes(deleteDomain)) {
      this.props.deleteCustomDomainIndicators({ deleteDomainUuid });
    }

    if (
      domain &&
      (domain.includes(',') ||
        !domain.includes('.') ||
        domain[0] === '.' ||
        domain[domain.length - 1] === '.') &&
      !deleteDomain
    ) {
      value = value.filter((el) => el !== domain);
    }

    this.setState({ value, searchValue: '' });
    this.setState({ isLoading: false });
  };

  render() {
    // console.log(this.props);
    const { value, searchValue } = this.state;
    return (
      <Select
        autoFocus
        style={{ width: '392px' }}
        value={value}
        searchValue={searchValue}
        mode="tags"
        onInputKeyDown={(e) => {
          if (e.key === 'Enter') {
            if (!searchValue || value.includes(searchValue)) {
              e.stopPropagation();
              e.preventDefault();
              if (value.includes(searchValue)) {
                showNotification(
                  simpleErrorNotification({
                    statusCode: 100,
                    message: 'Asset already exists.',
                  }),
                );
              }
            }
          }
        }}
        onChange={this.handleChange}
        onSearch={this.handleSearch}
        notFoundContent={null}
        dropdownStyle={{ display: 'none' }}
      />
    );
  }
}

export default MultipleSelect;
